module.exports = __webpack_public_path__ + "assets/img/questions_measureStand.b322edca.png";